import { getUnpaginatedAll } from '../../../helpers/getUnpaginatedAll'
import { ecbrRequest } from '../../request/ecbrRequest'

export const certificates = {
  getAll: async (...[params, ...rest]) =>
    ecbrRequest.get('/certificates', { params }, ...rest),
  getById: async (id, params = {}) =>
    ecbrRequest.get(`/certificates/${id}`, { params }),
  getByBrandId: async (brandId, params = {}) =>
    ecbrRequest.get('/certificates', { params: { ...params, brandId } }),
  // getBrandCertificates: async (brandId, params = {}) =>
  //   ecbrRequest.get('/company/certificates', {
  //     params: { ...params, brandId }
  //   })
  getBrandCertificates: async (brandId, params = {}) => {
    const resp = await ecbrRequest.get('/company/certificates', {
      params: { ...params, brandId }
    })
    const { certName } = params
    let data = resp.data
    if (certName) {
      data = {
        ...data,
        data: data.data?.filter((cert) =>
          cert.product.name.toLowerCase().startsWith(certName.toLowerCase())
        )
      }
    }
    return { ...resp, data }
  },
  getAllBrandCertificates: async (brandId, params = {}) => {
    return {
      data: await getUnpaginatedAll(
        (pagination) =>
          ecbrRequest.get('/company/certificates', {
            params: { ...params, ...pagination, brandId }
          }),
        params.page,
        params.take
      )
    }
  },
  getAllCompanyCertificatePillars: async (certificateId, params = {}) => {
    return {
      data: await getUnpaginatedAll(
        (pagination) =>
          ecbrRequest.get('/company/pillars', {
            params: { ...params, ...pagination, certificateId }
          }),
        params.page,
        params.take
      )
    }
  }
}
